import { render, staticRenderFns } from "./VuesticAdvancedColorPicker.vue?vue&type=template&id=962b85ee"
import script from "./VuesticAdvancedColorPicker.vue?vue&type=script&lang=js"
export * from "./VuesticAdvancedColorPicker.vue?vue&type=script&lang=js"
import style0 from "./VuesticAdvancedColorPicker.vue?vue&type=style&index=0&id=962b85ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports